import { Moon, Sun } from 'lucide-react';
import { useThemeMode } from '../../contexts/ThemeContext';
import { FloatingButton } from './styles';

/**
 * ⚠️ COMPONENTE TEMPORÁRIO — apenas para testar a engine de tema (EASYJUR-5735).
 * Botão flutuante global que alterna light/dark. Remover quando o toggle
 * definitivo entrar (topbar). Não faz parte do design final.
 */
export default function DarkModeToggle() {
    const { isDark, toggle } = useThemeMode();

    return (
        <>
            <FloatingButton
                type="button"
                onClick={toggle}
                title="Alternar tema (temporário)"
                aria-label="Alternar tema claro/escuro"
            >
                {isDark ? <Sun size={22} /> : <Moon size={22} />}
            </FloatingButton>
        </>
    );
}
